import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface SectionProps {
  children: React.ReactNode;
  background?: "white" | "cream" | "primary" | "gradient" | "gray";
  className?: string;
  id?: string;
  noPadding?: boolean;
}

const Section: React.FC<SectionProps> = ({ children, background = "white", className, id, noPadding = false }) => {
  const bgClasses = {
    white: "bg-surface",
    cream: "bg-background",
    primary: "bg-primary text-primary-foreground",
    gradient: "bg-gradient-to-b from-background to-surface",
    gray: "bg-gray-100",
  };

  return (
    <section id={id} className={cn(bgClasses[background], !noPadding && "section-padding", className)}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="container-custom"
      >
        {children}
      </motion.div>
    </section>
  );
};

export default Section;
